import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://groovie-business-api-production.up.railway.app/api/v1';

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/broadcast/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Login failed');
      localStorage.setItem('broadcast_token', data.token);
      if (data.station) localStorage.setItem('broadcast_station', JSON.stringify(data.station));
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#1e1b4b 0%,#312e81 60%,#4338ca 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ background:'#fff', borderRadius:16, padding:40, width:'100%', maxWidth:420, boxShadow:'0 25px 50px rgba(0,0,0,0.25)' }}>
        {/* Brand */}
        <div style={{ textAlign:'center', marginBottom:28, cursor:'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">
          <div style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:52, height:52, borderRadius:14, background:'linear-gradient(135deg,#6366f1,#818cf8)', marginBottom:12 }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={2} style={{width:26,height:26}}>
              <circle cx="12" cy="12" r="2"/><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"/><path d="M19.1 4.9C23 8.8 23 15.2 19.1 19.1"/>
            </svg>
          </div>
          <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:'#0f172a' }}>Groovie Broadcast</h1>
          <p style={{ margin:'4px 0 0', fontSize:13, color:'#64748b' }}>Sign in to your broadcast dashboard</p>
        </div>

        {error && (
          <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:'10px 14px', marginBottom:16, color:'#dc2626', fontSize:13 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Email</label>
            <input
              type="email" required value={form.email}
              onChange={e => set('email', e.target.value)}
              placeholder="station@example.com"
              style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #e2e8f0', borderRadius:8, fontSize:14, outline:'none', boxSizing:'border-box' }}
              onFocus={e => e.target.style.borderColor='#6366f1'}
              onBlur={e => e.target.style.borderColor='#e2e8f0'}
            />
          </div>
          <div>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Password</label>
            <input
              type="password" required value={form.password}
              onChange={e => set('password', e.target.value)}
              placeholder="••••••••"
              style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #e2e8f0', borderRadius:8, fontSize:14, outline:'none', boxSizing:'border-box' }}
              onFocus={e => e.target.style.borderColor='#6366f1'}
              onBlur={e => e.target.style.borderColor='#e2e8f0'}
            />
          </div>
          <button
            type="submit" disabled={loading}
            style={{ width:'100%', padding:'11px', borderRadius:8, border:'none', cursor: loading ? 'not-allowed' : 'pointer', background: loading ? '#c7d2fe' : 'linear-gradient(135deg,#6366f1,#4f46e5)', color:'#fff', fontWeight:700, fontSize:14, marginTop:4 }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign:'center', marginTop:20, fontSize:13, color:'#64748b' }}>
          No account?{' '}
          <Link to="/register" style={{ color:'#6366f1', fontWeight:600, textDecoration:'none' }}>Register your station</Link>
        </p>
      </div>
    </div>
  );
}
